import projectThumb1 from '../assets/thumbnails/projectThumb1.png'
import projectThumb2 from '../assets/thumbnails/projectThumb2.png'
import thumb3 from '../assets/thumbnails/thumb3.png'
import projectThumb4 from '../assets/thumbnails/projectThumb4.png'
import projectThumb5 from '../assets/thumbnails/projectThumb5.png'
import projectThumb6 from '../assets/thumbnails/projectThumb6.png'

const Data =  [
    {
        key: 6,
        img: projectThumb6,
        title: "Mock Restaurant Page",
        description: "Tech Used: HTML, CSS, React.js, firebase realtime database",
        gitLink: "https://github.com/DSmathers/tOP_Restaurant",
        demoLink: "https://dsmathers.github.io/tOP_Restaurant",

    },
    {
        key: 5,
        img: projectThumb5,
        title: "Personal Library Manager",
        description: "Tech Used: HTML, CSS, React.js, localStorage API",
        gitLink: 'https://github.com/DSmathers/tOP_Library',
        demoLink: 'https://dsmathers.github.io/tOP_Library/',
    },
    {
        key: 1,
        img: projectThumb1,
        title: "Compound Interest Calc",
        description: "Tech Used: HTML, CSS, JavaScript",
        gitLink: "https://github.com/DSmathers/CompoundInterestCalc",
        demoLink: "https://dsmathers.github.io/CompoundInterestCalc/",
    },
    
    {
        key: 4,
        img: projectThumb4,
        title: "Command Line Blackjack",
        description: "Tech Used: Python",
        gitLink: "https://github.com/DSmathers/Blackjack.py",
        demoLink: "https://replit.com/@DanielSmathers/Blackjackpy#Blackjack.py",
    },
    {
        key: 3,
        img: thumb3,
        title: "Technical Documentation Page",
        description: "Tech Used: HTML and CSS",
        gitLink: "https://github.com/DSmathers/Technical-Documentation-Skeleton",
        demoLink: "https://codepen.io/D-Smathers/full/PoGwOwg",
    },
    {
        key: 2,
        img: projectThumb2,
        title: "React Portfolio Website",
        description: "Tech Used: React.js and CSS",
        gitLink: "https://github.com/DSmathers/react-portfolio",
        demoLink: "https://dsmathers.github.io",
    },
    
    
]

export default Data;